import React from 'react';
import { NewCaseIcon, MessageIcon, DocumentIcon, ReplyIcon } from './UserDashboardIcons';

const StatusBadge: React.FC<{status: 'In Progress' | 'Completed' | 'New'}> = ({ status }) => {
    const statusClasses = {
        'In Progress': 'bg-yellow-100 text-yellow-800',
        'Completed': 'bg-green-100 text-green-800',
        'New': 'bg-blue-100 text-blue-800',
    };
    return (
        <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${statusClasses[status]}`}>
            {status}
        </span>
    );
};


export const UserDashboardOverview: React.FC = () => {
    return (
        <main className="layout-content-container flex flex-col max-w-[960px] flex-1 bg-white bg-opacity-80 backdrop-blur-md rounded-xl shadow-lg p-6 overflow-y-auto border border-slate-200">
            <header className="flex flex-wrap justify-between items-center gap-3 pb-6 border-b border-slate-300">
                <div className="flex flex-col gap-1">
                    <p className="text-blue-900 tracking-tight text-3xl font-bold">Dashboard</p>
                    <p className="text-slate-500 text-sm">¡Bienvenido! Aquí tienes un resumen de tu actividad.</p>
                </div>
                <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors duration-200 text-sm font-medium shadow-md hover:shadow-lg">
                    <NewCaseIcon />
                    Nuevo Caso
                </button>
            </header>
            
            <section>
                <h2 className="text-blue-800 text-xl font-semibold pt-6 pb-4">Resumen</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div className="flex flex-col gap-2 rounded-lg p-5 border border-slate-200 bg-blue-50">
                        <p className="text-slate-600 text-sm font-medium">Casos Activos</p>
                        <p className="text-blue-700 text-3xl font-bold">2</p>
                    </div>
                    <div className="flex flex-col gap-2 rounded-lg p-5 border border-slate-200 bg-blue-50">
                        <p className="text-slate-600 text-sm font-medium">Casos Totales</p>
                        <p className="text-blue-700 text-3xl font-bold">5</p>
                    </div>
                    <div className="flex flex-col gap-2 rounded-lg p-5 border border-slate-200 bg-blue-50">
                        <p className="text-slate-600 text-sm font-medium">Documentos</p>
                        <p className="text-blue-700 text-3xl font-bold">10</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 className="text-blue-800 text-xl font-semibold pt-8 pb-4">Casos Recientes</h2>
                <div className="overflow-x-auto">
                    <div className="rounded-lg border border-slate-300 bg-white">
                        <table className="min-w-full">
                            <thead className="bg-slate-50">
                                <tr>
                                    <th className="px-4 py-3 text-left text-slate-500 text-xs font-medium uppercase tracking-wider">ID Caso</th>
                                    <th className="px-4 py-3 text-left text-slate-500 text-xs font-medium uppercase tracking-wider">Estado</th>
                                    <th className="px-4 py-3 text-left text-slate-500 text-xs font-medium uppercase tracking-wider">Fecha</th>
                                    <th className="px-4 py-3 text-left text-slate-500 text-xs font-medium uppercase tracking-wider">Infracción</th>
                                    <th className="px-4 py-3 text-left text-slate-500 text-xs font-medium uppercase tracking-wider">País</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-200">
                                <tr>
                                    <td className="px-4 py-3 text-slate-700 text-sm">#12345</td>
                                    <td className="px-4 py-3 text-sm"><StatusBadge status="In Progress" /></td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">2023-08-15</td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">Exceso de velocidad</td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">Alemania</td>
                                </tr>
                                <tr>
                                    <td className="px-4 py-3 text-slate-700 text-sm">#67890</td>
                                    <td className="px-4 py-3 text-sm"><StatusBadge status="Completed" /></td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">2023-07-20</td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">Aparcamiento</td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">Francia</td>
                                </tr>
                                <tr>
                                    <td className="px-4 py-3 text-slate-700 text-sm">#11223</td>
                                    <td className="px-4 py-3 text-sm"><StatusBadge status="New" /></td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">2023-09-05</td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">Semáforo en rojo</td>
                                    <td className="px-4 py-3 text-slate-600 text-sm">España</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-8">
                <section>
                    <h2 className="text-blue-800 text-xl font-semibold pb-4">Mensajes</h2>
                    <div className="space-y-3">
                        <div className="flex items-start gap-3 p-3 rounded-lg border border-slate-200 bg-white hover:shadow-md transition-shadow duration-200">
                            <div className="text-blue-600 flex items-center justify-center rounded-lg bg-blue-100 shrink-0 size-10 mt-0.5"><MessageIcon /></div>
                            <div className="flex-1">
                                <p className="text-slate-800 text-sm font-medium line-clamp-1">Nuevo mensaje de soporte</p>
                                <p className="text-slate-500 text-xs line-clamp-1">2023-09-10</p>
                            </div>
                            <button className="text-slate-500 hover:text-blue-600 transition-colors"><ReplyIcon /></button>
                        </div>
                        <div className="flex items-start gap-3 p-3 rounded-lg border border-slate-200 bg-white hover:shadow-md transition-shadow duration-200">
                           <div className="text-blue-600 flex items-center justify-center rounded-lg bg-blue-100 shrink-0 size-10 mt-0.5"><MessageIcon /></div>
                            <div className="flex-1">
                                <p className="text-slate-800 text-sm font-medium line-clamp-1">Actualización caso #12345</p>
                                <p className="text-slate-500 text-xs line-clamp-1">2023-09-05</p>
                            </div>
                            <button className="text-slate-500 hover:text-blue-600 transition-colors"><ReplyIcon /></button>
                        </div>
                    </div>
                </section>
                <section>
                    <h2 className="text-blue-800 text-xl font-semibold pb-4">Documentos</h2>
                    <div className="space-y-3">
                         <div className="flex items-start gap-3 p-3 rounded-lg border border-slate-200 bg-white hover:shadow-md transition-shadow duration-200">
                            <div className="text-blue-600 flex items-center justify-center rounded-lg bg-blue-100 shrink-0 size-10 mt-0.5"><DocumentIcon /></div>
                            <div className="flex-1">
                                <p className="text-slate-800 text-sm font-medium line-clamp-1">Notificación de Multa</p>
                                <p className="text-slate-500 text-xs line-clamp-1">Subido el 2023-08-20</p>
                            </div>
                             <button className="text-slate-500 hover:text-green-600 transition-colors"><NewCaseIcon/></button>
                        </div>
                         <div className="flex items-start gap-3 p-3 rounded-lg border border-slate-200 bg-white hover:shadow-md transition-shadow duration-200">
                            <div className="text-blue-600 flex items-center justify-center rounded-lg bg-blue-100 shrink-0 size-10 mt-0.5"><DocumentIcon /></div>
                            <div className="flex-1">
                                <p className="text-slate-800 text-sm font-medium line-clamp-1">Ticket de Aparcamiento</p>
                                <p className="text-slate-500 text-xs line-clamp-1">Subido el 2023-07-25</p>
                            </div>
                             <button className="text-slate-500 hover:text-green-600 transition-colors"><NewCaseIcon/></button>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
};
